<template>
  <b-tabs pills content-class="mt-2 mb-4" v-if="value">
    <b-tab active>
      <template slot="title">
        Generale
        <b-badge variant="danger"
          v-if="countErrors()">
          {{ countErrors() }}
        </b-badge>
      </template>
      <form>
        <string-form-field
          label="Etichetta"
          :value="value.label"
          required
          :disabled="disabled"
          :error="findError('label')"
          @input="propertyChanged('label', $event)"
        />

        <workgroup-form-field
          label="Gruppo di lavoro"
          :value="value.workgroup"
          :required="!isAdministrator()"
          :disabled="disabled"
          :error="findError('workgroup')"
          @input="propertyChanged('workgroup', $event)"
        />
      </form>
    </b-tab>
  </b-tabs>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';

export default {
  mixins: [ EntityEditorMixin ],
}
</script>
